import { render } from "./ShopIntegrations.vue?vue&type=template&id=9b226c12&scoped=true"
import script from "./ShopIntegrations.vue?vue&type=script&lang=ts"
export * from "./ShopIntegrations.vue?vue&type=script&lang=ts"

import "./ShopIntegrations.vue?vue&type=style&index=0&id=9b226c12&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9b226c12"

export default script